
import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {RequestParameters} from '../shared/models/request-parameters/parameter.model';
import {Observable} from 'rxjs/Observable';

import {GlobalVariable} from '../global';
import {Agency} from './agency.model';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class AgencyService {
  private subject = new Subject<any>();
  public organizationReference = new Subject<any>();

  constructor(private http: HttpClient) {
  }

  getAgencies (parameters: RequestParameters = new RequestParameters()) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/agencies', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }

  getAgency (reference: string) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/agency/' + reference, {
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }

  postAgency (agency: Agency) {

    const body = this.normalizeAgencyData(agency);

    return this.http.post(GlobalVariable.BASE_API_URL + '/agencies', body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  putAgency (agency: Agency) {

    const body = this.normalizeAgencyData(agency);

    return this.http.put(GlobalVariable.BASE_API_URL + '/agency/' + agency.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );

  }

  deleteAgency (agency: Agency) {
    return this.http.delete(GlobalVariable.BASE_API_URL + '/agency/' + agency.reference)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  disableAgency(agency: Agency, stateToApply) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/agency/' + agency.reference + '/' + stateToApply)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  private normalizeAgencyData(agency: Agency): Agency {
    const body = Object.assign({}, agency);
    delete body.reference;
    if (body.manager !== null && body.manager !== undefined) {
      body.manager = body.manager.reference;
    }
    if (body.organization !== null && body.organization !== undefined) {
      body.organization = body.organization.reference;
    }
    if (body.city !== null && body.city !== undefined) {
      body.city = body.city.reference;
    }

    return body;
  }

  emitMessage(msg: object) {
    this.subject.next(msg);
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  onOrganizationChangeEmit(organizationReference) {
    this.organizationReference.next(organizationReference);
  }

  onOrganizationChangeRecieve() {
    return this.organizationReference.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/app/agency/agency.service.ts